import { Button } from '@mui/material'
import { alpha, styled, Theme } from '@mui/material/styles'

/**
 * Centralized button styled components and styles
 * Use these instead of repeating button styles across components
 *
 * Preferred approach: Use MUI's color prop with theme-defined variants:
 *   <Button color="gold" variant="outlined">Gold</Button>
 *   <Button color="blueCta" variant="contained">Blue CTA</Button>
 *   <Button color="danger" variant="outlined">Delete</Button>
 *
 * The styled components below are kept for backward compatibility.
 */

/**
 * Primary save button - blue CTA
 */
export const SaveButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.blueCta.main,
  color: theme.palette.blueCta.contrastText,
  '&:hover': {
    backgroundColor: theme.palette.blueCta.dark,
  },
}))

/**
 * Edit button - orange with dark text
 */
export const EditButton = styled(Button)(({ theme }) => ({
  color: theme.palette.orange.contrastText,
  fontWeight: 'bold',
  backgroundColor: alpha(theme.palette.orange.main, 0.7),
  '&:hover': {
    backgroundColor: theme.palette.orange.main,
    color: theme.palette.orange.contrastText,
  },
}))

/**
 * Create button - green
 */
export const CreateButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.text.complete,
  color: '#FFFFFF',
  '&:hover': {
    backgroundColor: alpha(theme.palette.text.complete, 0.85),
  },
}))

/**
 * Header button - green with white text
 */
export const HeaderButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.text.complete,
  color: '#FFFFFF',
  '&:hover': {
    backgroundColor: alpha(theme.palette.text.complete, 0.85),
  },
}))

/**
 * Delete button styles (for use with sx prop)
 */
export const deleteButtonStyles = (theme: Theme) => ({
  borderColor: theme.palette.danger.main,
  color: theme.palette.danger.main,
  fontWeight: 'bold',
  ':hover': {
    backgroundColor: theme.palette.danger.main,
    borderColor: theme.palette.danger.main,
    color: theme.palette.danger.contrastText,
  },
})

/**
 * Delete icon styles (for use with sx prop)
 */
export const deleteIconStyles = (theme: Theme) => ({
  borderColor: theme.palette.danger.main,
  fontSize: 30,
  color: theme.palette.danger.main,
  fontWeight: 'bold',
  ':hover': {
    backgroundColor: theme.palette.danger.main,
    borderColor: theme.palette.danger.main,
    borderRadius: '24px',
    color: theme.palette.danger.contrastText,
  },
})
